import React from 'react';
import { IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';

interface WelcomeMessageProps {
  userName: string;
  isRead: boolean;
  onDismiss?: () => void;
}

const WelcomeMessage: React.FC<WelcomeMessageProps> = ({
  userName,
  isRead,
  onDismiss,
}) => {
  const currentHour = new Date().getHours();
  let greeting = '';

  if (currentHour < 12) {
    greeting = 'Good Morning';
  } else if (currentHour < 18) {
    greeting = 'Good Afternoon';
  } else {
    greeting = 'Good Evening';
  }

  return (
    <div className='relative p-4 bg-blue-100 rounded-md text-blue-700 text-center mb-4'>
      {onDismiss && (
        <IconButton
          size='small'
          onClick={onDismiss}
          sx={{
            position: 'absolute',
            top: 4,
            right: 4,
            color: 'rgba(29, 78, 216, 0.7)',
            '&:hover': {
              color: 'rgba(29, 78, 216, 1)',
              backgroundColor: 'rgba(219, 234, 254, 0.5)',
            },
          }}
        >
          <Close fontSize='small' />
        </IconButton>
      )}
      <h2 className='text-xl font-bold'>
        {greeting}, {userName}!
      </h2>
      <p>
        Welcome to the Daily Bible Reading App.{' '}
        {
          <>
            {isRead ? (
              <span className='text-green-500 font-bold'>
                "You're all caught up for today!"
              </span>
            ) : (
              "We're glad to have you here!"
            )}
          </>
        }
      </p>
    </div>
  );
};

export default WelcomeMessage;
